export default function FeatureGrid() {
  const features = [
    {
      icon: 'ri-database-2-line',
      title: 'Product Database',
      desc: 'Centralized product list with all details organized in a single view',
      imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20laptop%20on%20a%20warm%20walnut%20wood%20desk%20displaying%20colorful%20spreadsheet%20interface%20surrounded%20by%20small%20potted%20succulents%20and%20a%20ceramic%20coffee%20mug%20morning%20sunlight%20through%20sheer%20curtains%20creating%20soft%20shadows%20clean%20productive%20workspace%20aesthetic%20editorial%20photography%20no%20text%20no%20logos&width=600&height=600&seq=feature-v2-01&orientation=squarish',
    },
    {
      icon: 'ri-funds-line',
      title: 'Price Comparison',
      desc: 'Multi-source pricing view to find the best deals across all sellers',
      imageUrl: 'https://readdy.ai/api/search-image?query=Two%20modern%20smartphones%20side%20by%20side%20on%20a%20warm%20sandy%20beige%20linen%20surface%20each%20showing%20different%20ecommerce%20interfaces%20with%20visible%20price%20tags%20soft%20diffused%20studio%20lighting%20overhead%20minimal%20composition%20product%20photography%20style%20no%20text%20no%20logos%20no%20people&width=600&height=600&seq=feature-v2-02&orientation=squarish',
    },
    {
      icon: 'ri-radar-line',
      title: 'Order Tracking',
      desc: 'Real-time status updates from purchase to delivery at your doorstep',
      imageUrl: 'https://readdy.ai/api/search-image?query=Cardboard%20shipping%20box%20with%20tracking%20barcode%20label%20on%20a%20rustic%20reclaimed%20wood%20table%20near%20a%20sunlit%20window%20with%20green%20outdoor%20garden%20view%20visible%20through%20glass%20soft%20natural%20morning%20light%20warm%20organic%20atmosphere%20editorial%20lifestyle%20photography%20no%20text%20no%20logos&width=600&height=600&seq=feature-v2-03&orientation=squarish',
    },
    {
      icon: 'ri-filter-3-line',
      title: 'Category Filters',
      desc: 'Smart filtering across 14 product categories for instant sorting',
      imageUrl: 'https://readdy.ai/api/search-image?query=Organized%20boutique%20retail%20shelf%20display%20with%20neatly%20folded%20colorful%20hoodies%20tshirts%20and%20accessories%20separated%20by%20wooden%20dividers%20warm%20ambient%20boutique%20lighting%20polished%20wood%20interior%20aesthetic%20editorial%20interior%20photography%20clean%20composition%20no%20text%20no%20logos%20no%20people&width=600&height=600&seq=feature-v2-04&orientation=squarish',
    },
    {
      icon: 'ri-shield-keyhole-line',
      title: 'Safety System',
      desc: 'Built-in verification to reduce fraud risk and protect your purchases',
      imageUrl: 'https://readdy.ai/api/search-image?query=Closeup%20of%20a%20modern%20digital%20padlock%20icon%20glowing%20softly%20on%20a%20dark%20charcoal%20tablet%20screen%20placed%20on%20a%20sleek%20marble%20surface%20with%20subtle%20reflections%20dark%20sophisticated%20tech%20aesthetic%20moody%20ambient%20lighting%20corporate%20security%20concept%20photography%20no%20text%20no%20logos&width=600&height=600&seq=feature-v2-05&orientation=squarish',
    },
    {
      icon: 'ri-speed-up-line',
      title: 'Fast Workflow',
      desc: 'Streamlined process that saves hours compared to manual shopping',
      imageUrl: 'https://readdy.ai/api/search-image?query=Overhead%20shot%20of%20an%20organized%20workspace%20with%20mechanical%20keyboard%20wireless%20mouse%20notebook%20and%20a%20digital%20tablet%20showing%20colorful%20graphs%20arranged%20on%20a%20light%20oak%20desk%20surface%20natural%20daylight%20from%20above%20geometric%20clean%20composition%20modern%20productive%20aesthetic%20editorial%20photography%20no%20text%20no%20logos%20no%20people&width=600&height=600&seq=feature-v2-06&orientation=squarish',
    },
  ];

  return (
    <section id="features" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 text-center mb-3">
          Core Features
        </h2>
        <p className="text-sm md:text-base text-foreground-500 text-center mb-12 max-w-xl mx-auto">
          Everything you need to transform your shopping experience into an organized, efficient workflow
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group relative rounded-2xl overflow-hidden aspect-square cursor-pointer border border-background-200/60 hover:border-accent-300 transition-all duration-300"
            >
              <img
                src={feature.imageUrl}
                alt={feature.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent flex flex-col justify-end p-5 md:p-6">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-400/90 mb-3">
                  <i className={`${feature.icon} text-base text-foreground-950`}></i>
                </div>
                <h3 className="text-base md:text-lg font-heading font-bold text-background-50 mb-1 whitespace-nowrap">
                  {feature.title}
                </h3>
                <p className="text-xs md:text-sm text-background-200/80 leading-relaxed">
                  {feature.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}